import React, { useEffect, useState } from "react";
import Profile from "../../template/Header/Profile";
import ItemGrid from "../../components/Modal/ItemGrid";
import { withStyles, IconButton, CircularProgress } from "@material-ui/core";
import { Button } from "../../components/ui/Buttons";
import { TextFieldSearch } from "../../components/TextField";
import { findAllProfissionalSaudeSelect } from "../../services/ProfissionalSaudeService";
import { findAllSujeitoAtencaoSelect } from "../../services/SujeitoAtencaoService";
import { InputDateForm } from "../../components/Modal/Input";
import { findAllStatusOrcamentoOdontologicoSelect } from "../../services/StatusOrcamentoService";
import { ReactSelect } from "../../components/Select/SelectSearch";
import { calcularValorTotalFindAllOrcamento } from "../../services/GerenciadorOrcamentosService";
import moment from "moment";
import VisibilityIcon from "../../components/Icon/VisibilityIcon";
import VisibilityOffIcon from "../../components/Icon/VisibilityOffIcon";
import InputSearchFilterCustom from "../../components/Input/InputSearchFilterCustom";
import { tiposFiltro } from "./constants";


const HeaderFilters = ({
  classes,
  filters,
  setFilters,
  loadOrcamentos,
  loading,
  getTipoFiltroDeData
}) => {
  const [valorTotal, setValorTotal] = useState(0);
  const [valorOculto, setValorOculto] = useState(true);
  const [loadingValor, setLoadingValor] = useState(false);
  const inputSearchFilterRef = React.useRef(null);

  const calcularValorTotal = async () => {
    try {
      setLoadingValor(true);
      const {
        statusOrcamentoOdontologico,
        numero,
        dataHoraLancamentoInicio,
        dataHoraLancamentoFim,
        dataAgendamentoInicio,
        dataAgendamentoFim,
        sujeitoAtencao,
        tipo,
        profissionalSolicitante,
        status,
        orcamentista,
        faturado,
        profissionalExecutante,
      } = filters;

      const statusOrcamentoOdontologicoNormalized = Array.isArray(
        statusOrcamentoOdontologico
      )
        ? statusOrcamentoOdontologico[0]
        : statusOrcamentoOdontologico;

      const dataHoraLancamentoInicioMoment = moment(
        dataHoraLancamentoInicio
      ).format("YYYY-MM-DDTHH:mm:ss");
      const dataHoraLancamentoFimMoment = dataHoraLancamentoFim
        ? moment(dataHoraLancamentoFim).format("YYYY-MM-DDT23:59:59")
        : null;
      const dataAgendamentoInicioMoment = dataAgendamentoInicio
        ? moment(dataAgendamentoInicio).format("YYYY-MM-DD")
        : null;
      const dataAgendamentoFimMoment = dataAgendamentoFim
        ? moment(dataAgendamentoFim).format("YYYY-MM-DD")
        : null;

      const variables = {
        ...(sujeitoAtencao?.id && { sujeitoAtencaoId: sujeitoAtencao.id }),
        ...(statusOrcamentoOdontologicoNormalized?.id &&
          tipo?.value === "ODONTOLOGICO" && {
            statusOrcamentoOdontologicoId:
              statusOrcamentoOdontologicoNormalized.id,
          }),
        ...(status?.value &&
          tipo?.value === "PROCEDIMENTO" && { status: status.value }),
        ...(numero && { numero: Number(numero) }),
       ...getTipoFiltroDeData(dataHoraLancamentoInicioMoment,dataHoraLancamentoFimMoment),
        ...(dataAgendamentoInicioMoment && {
          dataAgendamentoInicio: dataAgendamentoInicioMoment,
        }),
        ...(dataAgendamentoFimMoment && {
          dataAgendamentoFim: dataAgendamentoFimMoment,
        }),
        tipos: tipo ? [tipo.value] : ["ODONTOLOGICO", "PROCEDIMENTO"],
        ...(profissionalSolicitante?.id && {
          profissionalSolicitanteId: profissionalSolicitante.id,
        }),
        ...(orcamentista?.id && {
          orcamentistaId: orcamentista.id,
        }),
        ...(faturado?.value !== undefined && {
          faturado: faturado.value,
        }),
        ...(profissionalExecutante?.id && {
          executanteId: profissionalExecutante.id,
        }),
      };

      const total = await calcularValorTotalFindAllOrcamento(variables);
      setValorTotal(total || 0);
      setValorOculto(false);
    } catch (error) {
      console.error("Erro ao calcular valor total:", error);
      setValorTotal(0);
    } finally {
      setLoadingValor(false);
    }
  };

  const handleToggleValor = () => {
    if (valorOculto) {
      calcularValorTotal();
    } else {
      setValorOculto(true);
    }
  };

  const formatarValor = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  const handleChangeFilter = (value, field) => {
    setFilters({
      ...filters,
      [field]: value,
    });
  };

  const handleClickFilter = (source) => {
    if (source === "popover" && inputSearchFilterRef.current) {
      inputSearchFilterRef.current.closePopover();
    }
    setValorOculto(true);
    loadOrcamentos({ isClear: true });
  };

  const loadSujeitosAtencao = async (search, loadedOptions, { page }) => {
    try {
      const searchDTO = {
        sortDir: "ASC",
        sortField: "nome",
        pageSize: 20,
        pageNumber: page,
        search,
        ativo: true,
      };

      const { content, last } =
        (await findAllSujeitoAtencaoSelect({ searchDTO })) || {};
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch {
      openNotification("Erro ao carregar ", "error");
    }
  };

  const loadProfissionaisSaude = async (search, loadedOptions, { page }) => {
    try {
      const searchDTO = {
        sortDir: "ASC",
        sortField: "nome",
        pageSize: 20,
        pageNumber: page,
        search,
        ativo: true,
      };

      const { content, last } = await findAllProfissionalSaudeSelect({
        searchDTO,
      });
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error(error);
    }
  };

  const loadStatusOrcamentoOdontologico = async (
    search,
    loadedOptions,
    { page }
  ) => {
    try {
      const pageableDTO = {
        sortDir: "ASC",
        sortField: "nome",
        pageSize: 20,
        pageNumber: page,
      };

      const { content, last } = await findAllStatusOrcamentoOdontologicoSelect({
        pageableDTO,
        search,
        ativo: true,
      });
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error(error);
    }
  };

  const getValorTotal = () => {
    return valorOculto ? "" : formatarValor(valorTotal);
  };

  const getFilterStatus = () => {
    return (
      <ItemGrid label="Status" size={2}>
        {filters.tipo.value === "ODONTOLOGICO" ? (
          <TextFieldSearch
            id="gro-hfi-txt-sto"
            placeholder="Selecione"
            classInput={classes.reactSelect}
            classNotched={classes.notchedOutline}
            loadOptions={loadStatusOrcamentoOdontologico}
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            value={filters?.statusOrcamentoOdontologico}
            onChange={(e) =>
              handleChangeFilter(e, "statusOrcamentoOdontologico")
            }
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
          />
        ) : (
          <ReactSelect
            id="gro-hfi-sel-stp"
            placeholder="Selecione"
            className={classes.selectSearch}
            value={filters?.status}
            onChange={(e) => handleChangeFilter(e, "status")}
            options={[
              { value: "APROVADO", label: "Aprovado" },
              { value: "CANCELADO", label: "Cancelado" },
              { value: "INATIVO", label: "Inativo" },
              { value: "PENDENTE", label: "Pendente" },
            ]}
            isClearable
          />
        )}
      </ItemGrid>
    );
  };

  return (
    <div className={classes.content}>
      <div className={classes.contentTitleHeader}>
        <div className={classes.titleHeader}> Gerenciador de Orçamentos </div>
        <div className={classes.containerValor}>
          <div className={classes.contentValor}>
            <span>Valor total:</span>
            <div className={classes.valorContainer}>
              <div className={classes.contentValor}>
                {loadingValor ? (
                  <div className={classes.circularProgress}>
                    <CircularProgress size={18} />
                  </div>
                ) : (
                  <div className={classes.valor}>{getValorTotal()}</div>
                )}
              </div>
              <IconButton
                id="gro-hfi-btn-vis"
                onClick={handleToggleValor}
                disabled={loadingValor}
                className={classes.iconButton}
              >
                {valorOculto ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </div>
          </div>
          <Profile />
        </div>
      </div>
      <div className={classes.contentFilters}>
        <div className={classes.filters}>
          <div className={classes.inputSearchFilterCustom}>
            <InputSearchFilterCustom
              id="gro-hfi-inp-num"
              ref={inputSearchFilterRef}
              value={filters.numero}
              onChange={(e) => handleChangeFilter(e.target.value, "numero")}
              clearSearch={() => handleChangeFilter("", "numero")}
              placeholder="Pesquisar número"
              title="Filtros"
              type="number"
            >
              <div className={classes.containerFiltersCustom}>
                <div className={classes.rowFiltersCustom}>
                  <ItemGrid label="Data agendamento início" size={4}>
                    <InputDateForm
                      id="gro-hfi-inp-dai"
                      iconposition="end"
                      openTo="day"
                      views={["year", "month"]}
                      value={filters.dataAgendamentoInicio}
                      onChange={(e) =>
                        handleChangeFilter(e, "dataAgendamentoInicio")
                      }
                    />
                  </ItemGrid>
                  <ItemGrid label="Data agendamento fim" size={4}>
                    <InputDateForm
                      id="gro-hfi-inp-daf"
                      iconposition="end"
                      openTo="day"
                      views={["year", "month"]}
                      value={filters.dataAgendamentoFim}
                      onChange={(e) =>
                        handleChangeFilter(e, "dataAgendamentoFim")
                      }
                    />
                  </ItemGrid>
                </div>
                <div className={classes.rowFiltersCustom}>
                  <ItemGrid label="Solicitante" size={4}>
                    <TextFieldSearch
                      id="gro-hfi-txt-sol"
                      placeholder="Selecione"
                      classInput={classes.reactSelect}
                      classNotched={classes.notchedOutline}
                      loadOptions={loadProfissionaisSaude}
                      getOptionLabel={(option) => option?.nome}
                      getOptionValue={(option) => option?.id}
                      value={filters?.profissionalSolicitante}
                      onChange={(e) =>
                        handleChangeFilter(e, "profissionalSolicitante")
                      }
                      withPaginate
                      debounceTimeout={300}
                      additional={{
                        page: 0,
                      }}
                    />
                  </ItemGrid>
                  <ItemGrid label="Orçamentista" size={4}>
                    <TextFieldSearch
                      id="gro-hfi-txt-orc"
                      placeholder="Selecione"
                      classInput={classes.reactSelect}
                      classNotched={classes.notchedOutline}
                      loadOptions={loadProfissionaisSaude}
                      getOptionLabel={(option) => option?.nome}
                      getOptionValue={(option) => option?.id}
                      value={filters?.orcamentista}
                      onChange={(e) => handleChangeFilter(e, "orcamentista")}
                      withPaginate
                      debounceTimeout={300}
                      additional={{
                        page: 0,
                      }}
                    />
                  </ItemGrid>
                  <ItemGrid label="Executante" size={4}>
                    <TextFieldSearch
                      id="gro-hfi-txt-exe"
                      placeholder="Selecione"
                      classInput={classes.reactSelect}
                      classNotched={classes.notchedOutline}
                      loadOptions={loadProfissionaisSaude}
                      getOptionLabel={(option) => option?.nome}
                      getOptionValue={(option) => option?.id}
                      value={filters?.profissionalExecutante}
                      onChange={(e) => handleChangeFilter(e, "profissionalExecutante")}
                      withPaginate
                      debounceTimeout={300}
                      additional={{
                        page: 0,
                      }}
                    />
                  </ItemGrid>
                </div>
                <div className={classes.rowFiltersCustom}>
                  <ItemGrid label="Paciente" size={4}>
                    <TextFieldSearch
                      id="gro-hfi-txt-pac"
                      placeholder="Selecione"
                      classInput={classes.reactSelect}
                      classNotched={classes.notchedOutline}
                      loadOptions={loadSujeitosAtencao}
                      getOptionLabel={(option) => option?.nome}
                      getOptionValue={(option) => option?.id}
                      value={filters?.sujeitoAtencao}
                      onChange={(e) => handleChangeFilter(e, "sujeitoAtencao")}
                      withPaginate
                      debounceTimeout={300}
                      additional={{
                        page: 0,
                      }}
                    />
                  </ItemGrid>
                  <ItemGrid label="Faturado" size={4}>
                    <ReactSelect
                      id="gro-hfi-sel-fat"
                      placeholder="Selecione"
                      className={classes.selectSearch}
                      value={filters?.faturado}
                      onChange={(e) => handleChangeFilter(e, "faturado")}
                      options={[
                        { value: true, label: "Sim" },
                        { value: false, label: "Não" },
                      ]}
                      isClearable
                    />
                  </ItemGrid>
                </div>
                <div className={classes.containerButtonFiltersCustom}>
                  <Button
                    id="gro-hfi-btn-fp1"
                    bgColor="#00aca9"
                    onClick={() => handleClickFilter("popover")}
                    disabled={loading}
                    style={{ height: 40 }}
                  >
                    Filtrar
                  </Button>
                </div>
              </div>
            </InputSearchFilterCustom>
          </div>
          <ItemGrid label="Tipo filtro" size={2}>
            <ReactSelect
              placeholder="Selecione"
              className={classes.selectSearch}
              value={filters?.tipoFiltro}
              onChange={(e) => handleChangeFilter(e, "tipoFiltro")}
              options={tiposFiltro}
              isClearable
            />
          </ItemGrid>
          <ItemGrid label="Data início" size={2}>
            <InputDateForm
              id="gro-hfi-inp-dei"
              iconposition="end"
              openTo="day"
              views={["year", "month"]}
              value={filters.dataHoraLancamentoInicio}
              className={classes.inputData}
              onChange={(e) =>
                handleChangeFilter(e, "dataHoraLancamentoInicio")
              }
            />
          </ItemGrid>
          <ItemGrid label="Data fim" size={2}>
            <InputDateForm
              id="gro-hfi-inp-def"
              iconposition="end"
              openTo="day"
              views={["year", "month"]}
              value={filters.dataHoraLancamentoFim}
              className={classes.inputData}
              onChange={(e) => handleChangeFilter(e, "dataHoraLancamentoFim")}
            />
          </ItemGrid>
          <ItemGrid label="Tipo" size={2}>
            <ReactSelect
              id="gro-hfi-sel-tip"
              placeholder="Selecione"
              className={classes.selectSearch}
              value={filters?.tipo}
              onChange={(e) => handleChangeFilter(e, "tipo")}
              options={[
                { value: "ODONTOLOGICO", label: "Odontológico" },
                { value: "PROCEDIMENTO", label: "Procedimento" },
              ]}
              isClearable
            />
          </ItemGrid>
          {!!filters?.tipo && getFilterStatus()}
        </div>
        <Button
          id="gro-hfi-btn-fil"
          bgColor="#707C97"
          onClick={handleClickFilter}
          disabled={loading}
          style={{ height: 40 }}
        >
          Filtrar
        </Button>
      </div>
    </div>
  );
};

const styles = {
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 20px",
    maxHeight: "97px",
    height: "100%",
    background: "#fff",
    boxShadow:
      "10px 10px 25px rgba(112, 124, 151, 0.05), 15px 15px 35px rgba(112, 124, 151, 0.05)",
  },
  contentTitleHeader: {
    display: "flex",
    justifyContent: "space-between",
    height: "40px",
  },
  titleHeader: {
    fontWeight: 700,
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
    color: "#505050",
  },
  contentFilters: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttonFiltrar: {
    marginTop: "15px",
  },
  search: {
    height: 28,
    width: "100%",
    "&> div": {
      border: "1px solid rgba(220, 220, 220, 0.2)",
    },
  },
  notchedOutline: {
    border: "0",
  },
  reactSelect: {
    color: "#505050",
    background: "#F2F2F2",
    border: "0.5px solid rgba(220, 220, 220, 0.2)",
    borderRadius: "8px",
    fontSize: "12px !important",
  },
  selectSearch: {
    width: "100%",
  },
  containerValor: {
    display: "flex",
    gap: "16px",
  },
  valorContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  valorOculto: {
    width: "80px",
    height: "20px",
    backgroundColor: "#e0e0e0",
    borderRadius: "4px",
  },
  contentValor: {
    color: "#505050",
    width: '125px',
    
    "& > span": {
      fontWeight: "bold",
    }
  },
  valor: {
    width: "90px",
  },
  iconButton: {
    padding: "4px",
    "& svg": {
      fontSize: "16px",
    },
  },
  circularProgress: {
    padding: "2px",
    width: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerFiltersCustom: {
    width: "550px",
    display: "flex",
    flexDirection: "column",
  },
  rowFiltersCustom: {
    display: "flex",
  },
  filters: {
    display: "flex",
    width: "100%",
    alignItems: "center",
  },
  inputSearchFilterCustom: {
    marginRight: "15px",
  },
  containerButtonFiltersCustom: {
    justifyContent: "flex-end",
    display: "flex",
    marginTop: "10px",
  },
  inputData: {
    width: "100%",
  },
};

export default withStyles(styles)(HeaderFilters);
